export class JWTValidator {

  isExpired(jwt: string) {
    let isExpired = true;
    const payload = this.getPayload(jwt);

    if (payload) {

      if (Date.now() < payload.exp * 1000) {
        isExpired = false;
      }
    }
    return isExpired;
  }

  getPayload(jwt: string) {
    const jwtArray = jwt.split('.');
    let payload: Payload = null;
    if (jwtArray.length === 3) {
      payload = JSON.parse(atob(jwtArray[1])) as Payload;
    }
    return payload;
  }
}

interface Payload {
  exp: number;
}
